import { mapState, mapActions, mapGetters } from 'vuex'
import { lockModal, unLockModal } from '@/utils/helpers';

export default {
  computed: {
    ...mapGetters('browse', ['userBrowseHeaders']),
    ...mapState('browse', ['showNavBrowseOverlay'])
  },
  methods: {
    ...mapActions('browse', ['toggleNavBrowseCategoriesOverlay']),
    closeOverlay() {
      this.toggleNavBrowseCategoriesOverlay();
    },
  },
  watch: {
    showNavBrowseOverlay(value) {
      if (value) {
        lockModal();
      } else {
        unLockModal();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-secondary-nav/nav-browse-categories-overlay/nav-browse-categories-overlay.js